module.exports = __webpack_public_path__ + "img/03_sub_uk.5efcc33c.svg";